@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.logoImg {
  @include border-radius-full;
  width: 48px;
  height: 48px;
  background-color: var(--kg-theme);

  &.condensed {
    width: 20px;
    height: 20px;
  }

  &.disabled {
    background-color: var(--icon-soft);
  }
}

.logoFallback {
  @include border-radius-full;
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  background-color: var(--dark-purple-12);
  color: var(--dark-purple-9);
  text-transform: capitalize;
  @include typography-v2-title-xl;

  &.condensed {
    @include typography-v2-title-xs;
    width: 20px;
    height: 20px;
  }

  &.disabled {
    background-color: var(--background-soft);
  }
}